import './App.css';
import Home from './container/Home';
import Store from './redux/Store';
import { Provider } from 'react-redux';
import Header from './common/header/Header';
import Toast from './common/Toast';
import { useEffect } from 'react';


function App() {

  if (localStorage.getItem('token') === null) {
      window.location.replace('https://dev-cms.playbinge.in/proEngage');
  }else{
    return (
      <Provider store={Store}>
        <div >
          <Header />
          <div className='container-space'>
            <Home />
          </div>
          <Toast />
        </div>
      </Provider>
    );
  }

 
}

export default App;
